import { TextInputFormikPropTypes, TextInputFormikDefaultProps } from '../../Utils/TextInputPropTypes';

export const InputNamePropTypes = TextInputFormikPropTypes;

export const InputNameDefaultProps = TextInputFormikDefaultProps;

export default { InputNamePropTypes, InputNameDefaultProps };
